import UA from '@ali/tbm-ua';
import Url from '@ali/tbm-url';

/**
 * 获取影演域名
 */
const urlQuery = Url().query;
const getDomain = () => {
  const hostname = window.location.hostname;
  const regexp = /([^.]*?)\.?([^.]+)\.((?:taopiaopiao\.com)|(?:damai\.cn)|(?:piao\.com\.cn)|(?:piao\.cn)|(?:taobao\.com))$/i;
  const matched = hostname.match(regexp) || [];
  return {
    mainDomain: matched[3],
    subDomain: matched[2],
  };
};

/**
 * 根据请求域名中的副域名根据环境判断规则匹配对应mtop请求路径中的副域名
 * @param subDomain 请求域名中的副域名
 * @returns mtop请求路径中的副域名
 */
const getSubDomain = subDomain => {
  let retSubDomain;
  const isWaptest = subDomain.search(/waptest/i) > -1;
  const isWapa = subDomain.search(/pre-t|wapa|\bpre-tpp-act\b/i) > -1;
  retSubDomain = isWaptest ? 'waptest' : isWapa ? 'wapa' : 'm';
  return retSubDomain;
};

const getOtherSubDomain = subDomain => {
  let retSubDomain;
  if (subDomain === 'wapa' || /^pre-.*$/i.test(subDomain)) {
    retSubDomain = 'pre-mtop';
  } else if (subDomain === 'waptest') {
    retSubDomain = 'daily-mtop';
  } else {
    retSubDomain = 'mtop';
  }
  return retSubDomain;
};

const isInMiniContainer =
  UA.isWXApp ||
  UA.isBDminiApp ||
  UA.isBaiduApp ||
  UA.isKSminiApp ||
  UA.isWBApp ||
  UA.isXHSMiniProgram|| 
  UA.isIQiYiMiniProgram;

// 正则替换获得修正后的path值
const getPath = ({
  originPrefix,
  originSubDomain,
  originMainDomain,
  _prefix,
  _subDomain,
  _mainDomain,
  options,
}) => {
  const regexpPath = new RegExp(
    ['(' + originPrefix + ')', '(' + originSubDomain + ')', originMainDomain]
      .filter(a => a !== '()')
      .join('\\.')
  );

  const fixedStr =
    (_prefix ? _prefix + '.' : '') + _subDomain + '.' + _mainDomain;
  return options.path?.replace(regexpPath, fixedStr) || '';
};

const LibMtopMiddleware = options => {
  // 记录lib-mtop 透传到中间件里的初始mainDomain subDomain prefix 值，用于后面正则替换 修正path属性
  const {
    subDomain: originSubDomain,
    mainDomain: originMainDomain,
    prefix: originPrefix,
  } = options;

  const {
    mainDomain: movieShowDomain,
    subDomain: movieShowSubDomain,
  } = getDomain();

  // 电影演出所对应的prefix及domain，主域固定取值为当前页的mainDomain值，subDomain和prefix根据不同条件重新计算
  let _mainDomain = movieShowDomain;
  let _subDomain, _prefix;

  // 仅劫持电影演出域名的h5请求。其他域直接放过，lib-mtop会自动正确处理.
  if (
    movieShowDomain &&
    !options.WindVaneRequest &&
    !(window as any).skipTbmDomain
  ) {
    // url上通过h5mtop参数指定的环境优先级更高
    _subDomain = urlQuery.h5mtop ? urlQuery.h5mtop : movieShowSubDomain;
    _prefix = '';
    const isTppDomain = movieShowDomain === 'taopiaopiao.com';
    const isTaobao = movieShowDomain === 'taobao.com';

    // mainDomain属性直接使用当前页面的mainDomain
    // 重置prefix和subdomain
    if (isTppDomain || isTaobao) {
      // 票票域页面在小程序环境下使用wxapi，其余用acs.
      _prefix = isInMiniContainer ? 'wxapi' : 'acs';
      _subDomain = getSubDomain(_subDomain);
    } else {
      _subDomain = getOtherSubDomain(_subDomain);
    }

    const resPath = getPath({
      originMainDomain,
      originSubDomain,
      originPrefix,
      _subDomain,
      _mainDomain,
      _prefix,
      options,
    });
    return {
      path: resPath,
      subDomain: _subDomain,
      mainDomain: _mainDomain,
      prefix: _prefix,
    };
  }
  return {
    path: options.path,
    subDomain: options.subDomain,
    mainDomain: options.mainDomain,
    prefix: options.prefix,
  };
};

export default LibMtopMiddleware;
